<template>
  <section class="html-renderer">
    <slot />
  </section>
</template>

<script>
export default {
  name: 'HtmlRenderer',
};
</script>

<style lang="postcss"></style>
